import React from "react"
import { SeasonMeterComponent } from "./seasonMeterComponent"
import { SeasonTierComponent } from "./seasonTierComponent"

export const SeasonProgressComponent = () => {
    return (
        <div>
            <SeasonMeterComponent />
            <SeasonTierComponent />
        </div>
    )
}
